import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SubBanner from "../../components/SubBanner";
import bannerImg from "../../assets/img/terms_banner.png";
import { TERMS_DETAIL_URL } from "../../utils/urls";
import instance from "../../services/services";
import { setCookie, getCookie, removeCookie } from '../../utils/cookies';

function CustomizedAd() {
  const navigate = useNavigate();
  const { type } = useParams();
  const [activeTab, setActiveTab] = useState(2);
  const [termsTab, setTermsTab] = useState(0);
  const [termsDetail, setTermsDetail] = useState(null);
  const [isOptOutEnabled, setIsOptOutEnabled] = useState(false);
  const OPT_COOKIE = 'ttx_opt';
  const COOKIE_DOMAIN = window.location.hostname === 'localhost' ? undefined : '.kacelab.com';

  useEffect(() => {
    const cval = getCookie(OPT_COOKIE);
    setIsOptOutEnabled(cval === 'ON');
  }, []);



  const setOptOut = () => {
    setCookie(OPT_COOKIE, 'ON', 365, COOKIE_DOMAIN);
    setIsOptOutEnabled(true);
    window.location.reload();
    alert('처리 완료되었습니다.');
  };
  
  const resetOptOut = () => {
    setCookie(OPT_COOKIE, 'OFF', 365, COOKIE_DOMAIN);
    setIsOptOutEnabled(false);
    window.location.reload();
    alert('처리 완료되었습니다.');
  };
  
  const deleteRetargetAd = () => {
    removeCookie('BID', COOKIE_DOMAIN);
    removeCookie('ttx_did', COOKIE_DOMAIN);
    removeCookie('ttx_freq', COOKIE_DOMAIN);
    window.location.reload();
    alert('처리 완료되었습니다.');
  };
  

  const tabList = useMemo(() => [
    { label: '이용약관', url: '/terms/acetrader' },
    { label: '개인정보 처리방침', url: '/privacy' },
    { label: '맞춤형 광고안내', url: '/customizedAd' },
  ], []);

  const termsList = useMemo(() => [
    { id: 'acetrader', label: '맞춤형 광고안내', page_kind: '1' },
    { id: 'opt_out', label: 'NHN ACE OPT_OUT', page_kind: '2' },
    { id: 'target', label: 'NHN ACE 기본 타겟팅 안내', page_kind: '3' },
    { id: 'privacy', label: 'Privacy Policy', page_kind: '4' },
  ], []);

  useEffect(() => {
    const idx = termsList.findIndex(t => t.id === type);
    if (idx >= 0) {
      setTermsTab(idx);
      instance.post(TERMS_DETAIL_URL, {
        terms_type: 'adlib',
        page_kind: termsList[idx].page_kind,
      })
        .then(res => setTermsDetail(res.data.data.contents))
        .catch(() => setTermsDetail(null));
    } else {
      navigate('/customizedAd/acetrader', { replace: true });
    }
  }, [type, termsList, navigate]);

  useEffect(() => {
    if (['acetrader', 'opt_out', 'target', 'privacy'].includes(type)) {
      setActiveTab(2);
    } else {
      const tabIdx = tabList.findIndex(tab => tab.url.endsWith(type));
      if (tabIdx >= 0) setActiveTab(tabIdx);
    }
  }, [type, tabList]);

  // 약관 탭 클릭 시 이동
  const handleTabClick = (id, idx) => {
    setTermsTab(idx);
    navigate(`/customizedAd/${id}`);
  };

  return (
    <div className="terms">
      <SubBanner
        bgImg={bannerImg}
        title={"NHN ACE 맞춤형 광고안내"}
        tabs={tabList.map((tab, idx) => ({
          label: tab.label,
          url: tab.url,
          active: activeTab === idx,
          onClick: () => setActiveTab(idx),
        }))}
        location={[
          { label: "맞춤형 광고안내", url: "/customizedAd/acetrader", active: true },
        ]}
      />

      <div className="terms_section mt-[140px] md:mt-[210px] mb-[40px] mx-auto">
        <ul className="tab_list">
          {termsList.map((term, idx) => (
            <li
              key={term.id}
              className={termsTab === idx ? "active" : ""}
              onClick={() => handleTabClick(term.id, idx)}
            >
              {term.label}
            </li>
          ))}
        </ul>
      </div>

      {type !== 'opt_out' && (
        <div className="terms_section mb-[120px] mx-auto whitespace-pre-line">
          {termsDetail ? (
            <div dangerouslySetInnerHTML={{ __html: termsDetail }} />
          ) : (
            <div>데이터가 없습니다.</div>
          )}
        </div>
      )}

      {type === 'opt_out' && (
        <div className="terms_section unset term_opt mb-[120px] mx-auto whitespace-pre-line">
          <h3 className="red text_40">ACE Trader가 제공하는 배너 광고입니다.</h3>

          <div>
            <div className="pb-[32px] border-b border-[#E8E8E8]">
              <p className="mt-[24px] ml-[40px]">
                해당 광고는 귀하의 최근 행동(방문 사이트, 관심 상품 등)을 분석하여 제공하는 개인 맞춤형 광고 서비스입니다. ACE Trader는 연관성 없는 광고 노출로 인한 이용자의 불편함을 해소하고자 해당 서비스를 제공하고 있습니다. 이용자가 서비스 차단을 하였거나 이용자의 쿠키, 모바일 기기의 광고ID의 정보가 없는 경우 타겟팅 되지 않은 일반 광고가 노출 될 수 있습니다.
                당사는 이용자 브라우저의 익명화된 쿠키 및 모바일 기기의 광고ID(ADID/IDFA)를 기반으로 ACE Trader만의 특화된 분석 기술을 활용합니다. 수집한 정보에는 이용자의 민감한 개인 정보(이름, 연락처, 주민등록번호 등) 혹은 개인을 식별할 수 있는 정보는 포함되어 있지 않습니다.
                회사의 온라인 행태정보 수집에 관한 내용은 다음과 같습니다.
              </p>
              <ul className="my-[8px] ml-[80px]">
                <li>행태정보를 수집 처리하는 사업자명 : (주)엔에이치엔에이스</li>
                <li>수집하는 온라인 행태 정보의 종류</li>
                <li>웹/모바일 서비스 방문, 검색, 구매, IP 주소, 사용 관련 온라인상 이용자 활동정보</li>
                <li>온라인 행태 정보의 수집 방법</li>
                <li>이용자가 사이트 방문 시 생성 정보 수집 툴 등을 통해 자동 수집/전송</li>
                <li>제휴사로부터 제공받아 수집</li>
                <li>온라인 행태정보 수집 목적</li>
                <li>회사는 이용자의 관심, 성향에 기반한 개인 맞춤형 상품추천서비스(광고포함)를 제공하기 위하여 이용자의 행태 정보를 이용합니다.</li>
                <li>온라인 행태 정보의 저장 기간</li>
                <li>수집일로부터 2년</li>
              </ul>
              <p className="ml-[40px]">이용자 통제권 행사 방법 및 피해구제 방법 등 보다 자세한 개인정보보호정책은&nbsp;
                <a href="https://adcenter.acetrader.co.kr/term/onlinead.nhn" className="red underline" target="_blank" rel="noopener noreferrer">
                여기
                </a>
                를 눌러 확인하실 수 있습니다
              </p>
            </div>

            <div className="py-[32px] border-b border-[#E8E8E8]">
              <h4 className="mb-[24px] text_18 black">웹브라우저 기반의 맞춤형 광고 OPT OUT</h4>
              <div className="ml-[40px]">
                <p className="mb-[8px]">
                  개인 맞춤형 광고 정보의 삭제를 원하시면 
                  <button 
                    onClick={deleteRetargetAd}
                    className="red underline ml-[4px] cursor-pointer"
                  >
                    여기
                  </button>
                  를 클릭해주세요.<br/>
                  ACE Trader의 제휴 사이트 재방문시 다시 맞춤형 광고가 노출될 수 있습니다.
                </p>

                {!isOptOutEnabled ? (
                  <p>
                    개인 맞춤형 광고 서비스의 차단을 원하시면 
                    <button 
                      onClick={setOptOut}
                      className="red underline ml-[4px] cursor-pointer"
                    >
                      여기
                    </button>
                    를 클릭해주세요.<br/>
                    맞춤형 광고를 차단한 경우에도 타겟팅되지 않은 일반 광고가 노출될 수 있습니다.
                  </p>
                ) : (
                  <p>
                    귀하는 현재 개인 맞춤형 광고 서비스의 차단 설정 중입니다. 광고 서비스의 허용을 원하시면 
                    <button 
                      onClick={resetOptOut}
                      className="text-[#ff00c7] underline ml-[4px] cursor-pointer"
                    >
                      여기
                    </button>
                    를 클릭해주세요.<br/>
                    맞춤형 광고를 허용하면 최근 행동(방문사이트, 관심 상품 등)을 근거로 하는 연관상품 광고가 노출됩니다.
                  </p>
                )}
              </div>
            </div>

            <div className="py-[32px] border-b border-[#E8E8E8]">
              <h4 className="mb-[24px] text_18 black">모바일기기 기반의 맞춤형 광고 OPT OUT</h4>
              <ul className="ml-[40px] mb-[24px]">
                <li>Google Android
                  <ol className="ml-[20px] list-decimal">
                    <li>구글 설정앱을 엽니다.</li>
                    <li>관심기반 광고를 선택합니다.</li>
                    <li>수신 거부합니다.</li>
                  </ol>
                </li>
              </ul>
              <ul className="ml-[40px]">
                <li>Apple iOS
                  <ol className="ml-[20px] list-decimal">
                    <li>설정앱을 엽니다.</li>
                    <li>개인정보보호 선택합니다.</li>
                    <li>광고를 선택합니다.</li>
                    <li>광고추적 제한을 선택합니다.</li>
                  </ol>
                </li>
              </ul>
            </div>

            <div className="py-[32px]">
              <p>
                위의 설정은 브라우저 쿠키와 모바일 기기의 설정을 기반으로 하기 때문에 이를 삭제 및 변경할 경우 모두 초기화됩니다.<br/>
                또한 동일한 이용자라 하더라도 다른 브라우저나 다른 기기를 이용할 경우 광고가 다시 노출될 수 있습니다.
              </p>
              <div className="my-[24px]">
                <h4 className="mb-[24px] text_18 black">이용자 피해구제 방법</h4>
                <p>온라인 행태정보 수집 관련하여 의견 수렴 및 불만처리를 위한 연락처는 다음과 같습니다.</p>
              </div>
              <div className="my-[24px]">
                <h4 className="text_18 black">개인정보 보호책임자</h4>
                <ul className="ml-[40px] mb-[24px]">
                  <li>이름: 김유미</li>
                  <li>소속/직위 : 대표이사</li>
                  <li>E-MAIL : atx@nhnace.com</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CustomizedAd;
